import API from "..";

export interface CreateChannelData {
  channelName: string;
}

export const createChannel = async (data: CreateChannelData) => API.post<string>('/channel', data);